import type { IntercomJWTParams } from './types';

import { queryOptions, skipToken } from '@tanstack/react-query';

import { getIntercomJWT } from './api';

export const intercomQueries = {
  all: (pharmacyId: string | undefined) => ['intercom', pharmacyId] as const,
  jwt: (params: IntercomJWTParams | undefined) =>
    queryOptions({
      queryKey: [
        ...intercomQueries.all(params?.pharmacyId),
        'intercomJwt',
        params,
      ],
      queryFn: params?.pharmacyId ? () => getIntercomJWT(params) : skipToken,
    }),
};
